import React from 'react';
import { Tooltip } from '@material-ui/core';
import PropTypes from 'prop-types';
import { handleSidebarHover, handleSidebarHoverAway } from '../../../util/utility.functions';
import './style.css';

const SettingsIconActive = require('./SettingsIconActive.png');
const SettingsIconInactive = require('./SettingsIconInactive.png');

function SettingsIcon(props) {
  const { active, label } = props;
  const imgSrc = active ? SettingsIconActive : SettingsIconInactive;
  return (
    <Tooltip title={label}>
      <img
        src={imgSrc}
        alt=""
        height="20"
        width="20"
        onMouseOver={(event) => { handleSidebarHover(event, SettingsIconActive); }}
        onFocus={(event) => { handleSidebarHover(event, SettingsIconActive); }}
        onMouseLeave={(event) => { handleSidebarHoverAway(event, active, SettingsIconInactive); }}
      />
    </Tooltip>
  );
}

SettingsIcon.propTypes = {
  active: PropTypes.bool.isRequired,
  label: PropTypes.bool.isRequired,
};

export default SettingsIcon;
